import { ProductCardDetail, ProductDetail } from '../types';

const GROUP_ID_TYPE_MAP = {
  visual: [
    195, 302, 308, 310, 319, 323, 324, 325, 326, 327, 334, 335, 336, 337, 338, 339, 340, 341, 343, 346, 347, 348, 359,
    361, 362, 363, 364, 365, 366, 367, 368, 369, 370, 373, 374, 375, 376, 767,
  ],
  macbook: [746, 751],
};

const getProductType = (productGroupId: number) => {
  return Object.keys(GROUP_ID_TYPE_MAP).find(key => {
    return GROUP_ID_TYPE_MAP[key as keyof typeof GROUP_ID_TYPE_MAP].includes(productGroupId);
  });
};

type ProductTypeToDetailsConfigItem = {
  key: string;
  label: string;
  template?: (value: string) => string;
};

const productTypeToDetailsConfig: Record<string, Array<ProductTypeToDetailsConfigItem>> = {
  macbook: [
    {
      key: 'Screen Size (Inches)',
      label: 'Screen Size',
      template: (value: string) => `${value}"`,
    },
    {
      key: 'Operating system',
      label: 'Operating system',
      template: (value: string) => value,
    },
    {
      key: 'RAM (GB)',
      label: '',
      template: (value: string) => `${value}GB RAM`,
    },
    {
      key: 'Processor Type',
      label: 'Processor Type',
      template: (value: string) => value,
    },
  ],
  visual: [
    {
      key: 'Smart TV',
      label: 'Smart',
    },
    {
      key: 'Refresh Rate (Hz)',
      label: 'Refresh Rate',
      template: (value: string) => `Refresh rate: ${value}Hz`,
    },
    {
      key: 'Screen Resolution',
      label: 'Resolution',
      template: (value: string) => value,
    },
  ],
};

type ProductCardDetailsConfig = {
  type: string;
  details: Array<ProductCardDetail>;
};

const getProductCardDetailsConfig = (productGroupId: number, details: ProductDetail): ProductCardDetailsConfig => {
  const type = getProductType(productGroupId);

  if (!type) return { type: 'unknown', details: [] };

  const detailsTypeConfig = productTypeToDetailsConfig[type] ?? [];
  if (!detailsTypeConfig.length) return { type, details: [] };

  const productCardDetails = [];

  for (const detail of detailsTypeConfig) {
    if (details[detail.key] && details[detail.key][0]) {
      productCardDetails.push({
        accessibilityLabel: detail.label,
        value: detail.template ? detail.template(details[detail.key][0] as string) : detail.label,
      });
    }
  }

  return { type, details: productCardDetails };
};

export { getProductCardDetailsConfig };
